import React, { useState, useCallback } from "react";
import "./RentalForm.css";
import "../createPostLayout.css";
import VerticalAd from "../../VerticalBanner";
import { uploadToS3 } from "../../../Utils/Utils.js"
import { apiUrl, jsonAuthHeaders } from "../../../config/api.js"
import { devLog } from "../../../config/devLog.js"
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import VerifyCompanyModal from "../../../components/SignUpScreen/verifyModal/VerifyModal.js";



const RentalForm = () => {
  const navigate = useNavigate()
    // const { userId } = useSelector((state) => state.userReducer);
    const { userId, userDetails } = useSelector((state) => state.userReducer);
  
  const [formData, setFormData] = useState({
    type: "rent",
    location: "",
    city: "",
    pincode: "",
    rent: "",
    deposit: "",
    duration: "",
    durationPeriod: "",
    availableFrom: "",
    squareFeet: "",
    bedrooms: "",
    bathrooms: "",
    groceries: "",
    bus: "",
    rentalType: "",
    parking: false,
    pets: false,
    smoking: false,
    foodPref: "",
    gender: "",
    amenities: "",
    images: [],
    additionalDetails: "",
    salePrice:"",
    advance:"",
    nearBySchools:""
  });

  const [errors, setErrors] = useState({});
  const [showVerifyModal,setShowVerifyModal] = useState(false)
  const [adsRailFilled, setAdsRailFilled] = useState(false);

  const handleVerticalAdSlotState = useCallback((status) => {
    setAdsRailFilled(status === "filled");
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    const updatedValue =
      type === "checkbox" ? checked : type === "file" ? files : value;
    setFormData((prev) => ({ ...prev, [name]: updatedValue }));
  };

  const validate = () => {
    const newErrors = {};

     let nonValidationKeys = ["additionalDetails", "petsAllowed", "smokingAllowed"]
    let rentalKeys = ["rent", "deposit", "rentalDuration", "duration", "durationPeriod", "gender", "foodPref","rentalType"]
    let saleKeys = ["salePrice", "advance", "nearBySchools"]
    let skipableKeys = [...nonValidationKeys, ...formData.type==="rent"?saleKeys:rentalKeys]
    Object.keys(formData).forEach((key) => {
      if (skipableKeys.includes(key)===false && formData[key].toString().trim() === "") {
        newErrors[key] = "This field is required";
      }
    });
    // const requiredFields = [
    //   "location", "city", "pincode", "rent", "deposit", "duration",
    //   "durationPeriod", "availableFrom", "squareFeet", "bedrooms",
    //   "bathrooms", "groceries", "bus", "rentalType", "foodPref",
    //   "gender", "amenities"
    // ];
    // requiredFields.forEach((field) => {
    //   if (!formData[field] || formData[field].toString().trim() === "") {
    //     newErrors[field] = "This field is required";
    //   }
    // });
    devLog(newErrors)
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit =async (e) => {
    e.preventDefault();
    if (validate()) {
      // alert("Fo/rm submitted successfully!");
      devLog(formData);
      let expectedBuf = normalizeRentalPayload(formData);
      devLog(expectedBuf)
      const base64Images = await uploadToS3(expectedBuf.pictures)
      devLog("pictres",base64Images)
      const toastId = toast.loading("Creating your Listing...",{position: "bottom-center"});
      // return ""
      const response = await fetch(apiUrl("createRental"), {
        method: 'POST',
        headers: jsonAuthHeaders(),
        body: JSON.stringify({ title:expectedBuf.listingCategory+`: ${expectedBuf.bedRooms}bed | ${expectedBuf.bathRooms}bath`, categoryId:1, createdBy: userId, ...expectedBuf,  pictures:base64Images.join(",")}),
      });

      const data = await response.json();
       if (response.ok) {
      toast.update(toastId, {
        render: "Listing Created successfully 🎉",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true
      });
    } else {
      toast.update(toastId, {
        render: data.message || "Something went wrong 😕",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true
      });
    }
      setTimeout(() => {
                                  navigate("/home")
                                }, 3000);
      devLog(data)
    }
  };


  const normalizeRentalPayload = (payload) => {
  return {
    location: payload.location || "",
    pinCode: payload.pincode || "",
    monthlyRent: payload.rent || "",
    bedRooms: payload.bedrooms || "",
    squareFeet: payload.squareFeet || "",
    deposit: payload.deposit || "",
    petsAllowed: payload.pets ?? false,
    smokingAllowed: payload.smoking ?? false,
    Amenities: payload.amenities || "",
    additionalDetails: payload.additionalDetails || "",
    listingCategory: payload.type,
    availableFrom: payload.availableFrom ? new Date(payload.availableFrom) : new Date(),
    rentalDuration: `${payload.duration || ""} ${payload.durationPeriod || ""}`.trim(),
    nearByGroceries: payload.groceries || "",
    nearBySchools: payload.nearBySchools || "",
    rentalType: (payload.rentalType || "").trim(),
    busConnectivity: payload.bus || "",
    parking: payload.parking ?? false,
    foodPreference: payload.foodPref || "",
    preferredGender: payload.gender || "",
    salePrice: payload.salePrice || "",
    advance: payload.advance || "",
    duration: payload.duration || "",
    bathRooms: payload.bathrooms || "",
    city: payload.city || "",
    pictures: [...payload.images]
  };
};


  return (
    <div className="rental-container">
                         {showVerifyModal&& <VerifyCompanyModal isOpen={showVerifyModal} onClose={()=>{setShowVerifyModal(false)}} message={"You cannot proceed further with verifying yourself as corporate NRI, Please verify your corporate mail ID."}/>}
      {!adsRailFilled && (
        <div className="create-post-ad-probe" aria-hidden>
          <VerticalAd onSlotStateChange={handleVerticalAdSlotState} />
        </div>
      )}
      <div
        className={`create-post-layout ${adsRailFilled ? "create-post-layout--with-ad" : ""}`}
      >
        <div className="create-post-main">
      <div className="rental-header">
        <h3>Rental Listing</h3>
      </div>
      
      <div className="toggle-group">
        <button
          className={formData.type === "rent" ? "active" : ""}
          type="button"
          onClick={() => setFormData({ ...formData, type: "rent" })}
        >
          Rental
        </button>
        <button
          className={formData.type === "sale" ? "active" : ""}
          type="button"
          onClick={() => setFormData({ ...formData, type: "sale" })}
        >
          Sale
        </button>
      </div>

      <form onSubmit={(e)=>{if(!userDetails.is_verified){ setShowVerifyModal(true)}else{handleSubmit(e)}}}>
        <InputField name="location" label="Location" value={formData.location} onChange={handleChange} error={errors.location} />
        <div className="double">
          <InputField name="city" label="City" value={formData.city} onChange={handleChange} error={errors.city} />
          <InputField name="pincode" label="Pincode" value={formData.pincode} onChange={handleChange} error={errors.pincode} />
        </div>
        <div className="double" style={{display: formData.type==="sale"?"grid":"none"}}>
          <InputField name="salePrice" label="Sale Price" value={formData.salePrice} onChange={handleChange} error={errors.salePrice} />
          <InputField name="advance" label="Advance" value={formData.advance} onChange={handleChange} error={errors.advance} />
        </div>
        <div className="double" style={{display: formData.type==="rent"?"grid":"none"}}>
          <InputField name="rent" label="Monthly Rent" value={formData.rent} onChange={handleChange} error={errors.rent} />
          <InputField name="deposit" label="Deposit" value={formData.deposit} onChange={handleChange} error={errors.deposit} />
        </div>
        <div className="double" style={{display: formData.type==="rent"?"grid":"none"}}>
          <InputField name="duration" label="Rental Duration" value={formData.duration} onChange={handleChange} error={errors.duration} />
          <div style={{width:"100%"}}>
            <label>Duration Period</label>
            <select
              name="durationPeriod"
              value={formData.durationPeriod}
              onChange={handleChange}
              className={errors.durationPeriod ? 'error-border' : ''}
            >
              <option value="">Select Period</option>
              <option value="Months">Months</option>
              <option value="Years">Years</option>
            </select>
            {errors.durationPeriod && <p className="error">{errors.durationPeriod}</p>}
          </div>
        </div>
        <div className="double">
          <InputField type="date" name="availableFrom" label="Available From" value={formData.availableFrom} onChange={handleChange} error={errors.availableFrom} />
          <InputField name="squareFeet" label="Square Feet" value={formData.squareFeet} onChange={handleChange} error={errors.squareFeet} />
        </div>
        <div className="double">
          <InputField name="bedrooms" label="Bedrooms" value={formData.bedrooms} onChange={handleChange} error={errors.bedrooms} />
          <InputField name="bathrooms" label="Bathrooms" value={formData.bathrooms} onChange={handleChange} error={errors.bathrooms} />
        </div>
        <div className="double">
          <InputField name="groceries" label="Nearby Groceries" value={formData.groceries} onChange={handleChange} error={errors.groceries} />
          <InputField name="bus" label="Bus Connectivity" value={formData.bus} onChange={handleChange} error={errors.bus} />
        </div>
        <div className="double" style={{display: formData.type==="rent"?"grid":"none"}}>
          <div style={{width:"100%"}}>
            <label>Rental Type</label>
            <select
              name="rentalType"
              value={formData.rentalType}
              onChange={handleChange}
              className={errors.rentalType ? 'error-border' : ''}
            >
              <option value="">Select Type</option>
              <option value="Guest">Guest</option>
              <option value="Lease">Lease</option>
              <option value="Sublease">Sublease</option>
            </select>
            {errors.rentalType && <p className="error">{errors.rentalType}</p>}
          </div>
          <label className="checkbox-field">
            Parking?
            <input type="checkbox" name="parking" checked={formData.parking} onChange={handleChange} />
          </label>
        </div>
          <div className="double" style={{display: formData.type==="sale"?"grid":"none"}}>
          <InputField name="nearBySchools" label="NearBy Schools" value={formData.nearBySchools} onChange={handleChange} error={errors.nearBySchools} />
          <label className="checkbox-field">
            Parking?
            <input type="checkbox" name="parking" checked={formData.parking} onChange={handleChange} />
          </label>
        </div>
        <div className="double">
          <label className="checkbox-field">
            Pets Allowed?
            <input type="checkbox" name="pets" checked={formData.pets} onChange={handleChange} />
          </label>
          <label className="checkbox-field">
            Smoking Allowed?
            <input type="checkbox" name="smoking" checked={formData.smoking} onChange={handleChange} />
          </label>
        </div>
        <div className="double" style={{display: formData.type==="rent"?"grid":"none"}}>
          

          <div style={{display:"flex", gap:"10px"}}>
      <div style={{width:"100%"}}><label>Food Preference</label>
      <select
        name="foodPref"
        value={formData.foodPref}
        onChange={handleChange}
        className={errors.foodPref ? 'error-border' : ''}
      >
        <option value="">Select Option</option>
        <option value="Veg">Veg</option>
        <option value="Non-Veg">Non-Veg</option>
        <option value="Any">Any</option>

       
      </select>
      {errors.foodPref && <p className="error">{errors.foodPref}</p>}
      </div>

      </div>

       <div style={{display:"flex", gap:"10px"}}>
      <div style={{width:"100%"}}><label>Preferred Gender</label>
      <select
        name="gender"
        value={formData.gender}
        onChange={handleChange}
        className={errors.gender ? 'error-border' : ''}
      >
        <option value="">Select Option</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
        <option value="Any">Any</option>


       
      </select>
      {errors.gender && <p className="error">{errors.gender}</p>}
      </div>

      </div>


          {/* <InputField name="foodPref" label="Food Preference" value={formData.foodPref} onChange={handleChange} error={errors.foodPref} /> */}
          {/* <InputField name="gender" label="Preferred Gender" value={formData.gender} onChange={handleChange} error={errors.gender} /> */}
        </div>
        <InputField name="amenities" label="Amenities" value={formData.amenities} onChange={handleChange} error={errors.amenities} />

        <div className="file-upload">
  <label htmlFor="images">Upload Pictures:</label>
  <input
    type="file"
    name="images"
    multiple
    onChange={handleChange}
    id="images"
    className={errors.images ? "error-border" : ""}
  />
  {errors.images && <p className="error">{errors.images}</p>}
</div>





        <label className="textarea-label">
          Additional Details</label>
          <textarea
            name="additionalDetails"
            value={formData.additionalDetails}
            placeholder="Enter additional details"
            onChange={handleChange}
          />
        

        <button type="submit" className="submit-btn" style={{ margin:"auto", width:"100%", maxWidth:"250px",cursor:"pointer"}}>Submit</button>
      </form>
        </div>
        {adsRailFilled && (
          <aside className="create-post-ads" aria-label="Advertisement">
            <div className="create-post-ads-inner">
              <span className="create-post-ads-label">Advertisement</span>
              <VerticalAd onSlotStateChange={handleVerticalAdSlotState} />
            </div>
          </aside>
        )}
      </div>
    </div>
  );
};

const InputField = ({ name, label, value, onChange, error, type = "text" }) => (
  <div className="input-wrapper">
    <label>{label}</label>
    <input name={name} type={type} value={value} onChange={onChange} placeholder={label} className={error ? "error-border" : ""} />
    {error && <p className="error">{error}</p>}
  </div>
);

export default RentalForm;
